import React from "react";
import { BsLinkedin, BsGithub, BsInstagram } from 'react-icons/bs';

const HeaderSocials = () => {
  return (
    <div className="flex md:flex-col flex-row items-center gap-8 absolute md:left-1 bottom-[150px] md:bottom-8 transition-all duration-300">
      <a href="https://www.linkedin.com/in/romina-molina-9a1579194/" target="_blank" rel="noreferrer" className="bt-social">
        <BsLinkedin size={24} />
      </a>
      <a href="https://github.com/RomiMolina" target="_blank" rel="noreferrer" className="bt-social">
        <BsGithub size={24} />
      </a>
      <a href="https://www.instagram.com/rominamolina/?next=%2F" target="_blank" rel="noreferrer" className="bt-social">
        <BsInstagram size={24} />
      </a>
  
    </div>
  );
};

export default HeaderSocials;
